import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReportDiscrepancyComponent } from './report-discrepancy/report-discrepancy.component';
import { SearchDiscrepancyComponent } from './search-discrepancy/search-discrepancy.component';
import { DetailsDiscrepancyComponent } from './details-discrepancy/details-discrepancy.component';
import { AuthGuard } from './auth.guard';
import { RedirectComponent } from './redirect/redirect.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

const routes: Routes = [
  { path: 'report-discrep', component: ReportDiscrepancyComponent, canActivate: [AuthGuard]},
  { path: 'search-discrep', component: SearchDiscrepancyComponent, canActivate: [AuthGuard]},
  { path: 'details-discrep/:id/:id2', component: DetailsDiscrepancyComponent, canActivate: [AuthGuard]},
  { path: '', redirectTo: '/report-discrep', pathMatch: 'full' },  // redirect to `default-component`
  { path: 'callback', component: RedirectComponent } ,
  { path: 'unauthorized', component: UnauthorizedComponent } ,
  { path: '**', component: UnauthorizedComponent } // Wildcard route for a 404 page
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
